export default __webpack_public_path__ + "static/BackgroundTrees-acef929db332410fb1007f2496a45132.svg";